import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../State';
import { DoctorCatalogActions } from '../../../State/actions/mdqx/doctor/doctor-catalog.actions';
import { getDoctorCatalogFetched } from '../../../State/selectors/mdqx/doctor/doctor-catalog.selector';
import { BaseEntityResolver } from '../../resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class DoctorCatalogResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getDoctorCatalogFetched, DoctorCatalogActions.loadRequest({ Payload: {} }), store);
    }
}
